<template>
    <div class="global-search__search-area">
        <div class="row">
            <div class="col-12"><p class="result-count">{{ totalResults }}&nbsp;{{ localization.labels.results }}</p></div>
            <div class="col-12 col-md-4">
                <div class="form__input--with-icon">
                    <input class="form__input form__input--text" maxlength='100' v-model="keyword" @focus="showSuggestions = true" @blur="showSuggestions = false" @keyup="(e) => {onKeyUp(e)}" type="text" />
                    <label class="input__label input__icon" @click="search">
                        <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect x="0" y="0" width="398" height="40"></rect><filter x="-0.8%" y="-7.5%" width="101.5%" height="115.0%" filterUnits="objectBoundingBox" ><feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur><feOffset dx="3" dy="3" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite><feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.03 0" type="matrix" in="shadowInnerInner1"></feColorMatrix></filter></defs><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-379.000000, -220.000000)" fill-rule="nonzero"><g transform="translate(8.000000, 178.000000)"><g transform="translate(0.000000, 31.000000)"><g><use fill="#EFECEB" xlink:href="#path-1"></use><use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use></g><path  d="M385.996833,28 L380.764375,22.7675417 C379.781208,23.386625 378.622375,23.75 377.375,23.75 C373.853875,23.75 371,20.896125 371,17.375 C371,13.853875 373.853875,11 377.375,11 C380.896125,11 383.75,13.853875 383.75,17.375 C383.75,18.622375 383.385917,19.7819167 382.767542,20.764375 L388,25.9968333 L385.996833,28 Z M377.375,22.3333333 C380.108458,22.3333333 382.333333,20.1091667 382.333333,17.375 C382.333333,14.6408333 380.108458,12.4166667 377.375,12.4166667 C374.641542,12.4166667 372.416667,14.6408333 372.416667,17.375 C372.416667,20.1091667 374.641542,22.3333333 377.375,22.3333333 Z"  fill="#000000"></path></g></g></g></g></svg>
                    </label>
                </div>

                <template v-if="showSuggestions">
                    <ul class="suggestions filter--list">
                        <template v-for="(suggestion, index) in suggestions">
                            <li :class="['suggestion', selectedSuggestion === index ? 'active': '']" @click="setKeyword(index)">{{ suggestion }}</li>
                        </template>
                    </ul>
                </template>
            </div>
            <div class="col button-container">
                <button class="button button--primary" @click="search">{{ localization.buttons.search }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { helper } from "../../shared/helper";

    export default {
        name: "search-area",
        data() {
            return {
                keyword: this.$store.getters.keyword,
                selectedSuggestion: null,
                showSuggestions: false,
                timer: null,
                searchQueryNumber: 10,
                searchQueryOffset: 0,
            }
        },
        computed: {
            localization () {
                return this.$store.getters.localize
            },
            suggestions () {
                return this.$store.state.suggestions
            },
            results () {
                return this.$store.state.searchResults;
            },
            totalResults() {
				        return this.$store.getters.totalResultCount;
            }
        },
        methods: {
            setKeyword(index) {
                this.showSuggestions = true;
                this.keyword = this.suggestions[index];
            },
			onKeyUp(e) {
				if (e.key === "Enter") {
					if (this.selectedSuggestion) {
						this.keyword = this.suggestions[this.selectedSuggestion];
						this.showSuggestions = false;
						this.selectedSuggestion = null;
					}

					if (this.showSuggestions === false) { // Für Esc + Enter? :-O
						this.search();
					}

					return;
				}

				if (e.key === "Escape") {
					this.showSuggestions = false;

					return;
				}

				if (this.selectedSuggestion === null) {
					if (e.key === "ArrowUp") {
						this.selectedSuggestion = this.suggestions.length -1
					}

					if (e.key === "ArrowDown") {
						this.selectedSuggestion = 0;
					}
				} else {
					if (e.key === "ArrowUp") {
						if (this.selectedSuggestion > 0) {
							this.selectedSuggestion--;
						} else {
							this.selectedSuggestion = this.suggestions.length -1
						}
					}

					if (e.key === "ArrowDown") {
						if (this.selectedSuggestion < (this.suggestions.length -1)) {
							this.selectedSuggestion++;
						} else {
							this.selectedSuggestion = 0;
						}
					}
				}

                if (helper.keyboard.isChar(e) || helper.keyboard.isDelete(e)) {
                    if (this.timer) {
                        window.clearTimeout(this.timer);
                    }

                    this.timer = window.setTimeout(() => {
						this.$store.dispatch('setKeyword', { keyword: this.keyword });
						this.$store.dispatch('fetchResults');
                        this.showSuggestions = true
                    }, 200)
                }
            },
            search() {
                this.showSuggestions = false;
                this.$store.dispatch('setKeyword', { keyword: this.keyword });
                this.$store.dispatch('fetchResults');
            }
        },
        created() {
            let self = this;
            document.addEventListener('click', e => {
                if (!self.$el.contains(e.target)) {
                    self.showSuggestions = false;
                }
            });
        }
    }
</script>
